import React from 'react';
import ReactDOM from 'react-dom';
import 'react-html5-camera-photo/build/css/index.css';
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
